export default angular.module("mars.vet.dnareports.controller.eic",[]).controller('EICController', function($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService, TranslationService, UtilityService,reportdata) {
  'ngInject'
  var resultString = reportdata.resultString;
  var sampleDetails = reportdata.sampleDetails;


    $scope.getVersionFeature = UtilityService.getVersionFeature('EIC');
    if ($scope.getVersionFeature) {
        var reportType = 'online';
        $scope.onloadFun = function() {
            reportType = 'pdf';
        }
        EntryService.getEntry(EntryIDService.getEntryID('Exercise Induced Collapse')).then(function(response) {
            var fields = response.fields;
            //        $scope.title = fields.title;
            if (reportType != 'pdf') {
                $rootScope.pageTitle = fields.title;
            }
            $scope.title = fields.title;
            var disorderSnps = resultString.disorderSnps;
            var eicOutcome;
            var eicCopies;
            var eicStatus;
            var eicDesc = "";
            angular.forEach(disorderSnps, function(result, key) {
                if (disorderSnps !== undefined && disorderSnps.length > 0 && result['snp_name'].indexOf("DNM1") != -1) {
                    eicOutcome = result['outcome'];
                    eicCopies = result['copies'];
                }
            });
            if (eicOutcome == 'negative' && eicCopies == 0) {
                eicStatus = TranslationService.getTranslation('Clear');
                eicDesc = fields.description['Clear'];
            } else if (eicOutcome == 'positive' && eicCopies == 1) {
                eicStatus = TranslationService.getTranslation('Carrier');
                eicDesc = fields.description['Carrier'];
            } else if (eicOutcome == 'positive' && eicCopies == 2) {
                eicStatus = TranslationService.getTranslation('Affected');
                eicDesc = fields.description['Affected'];
            } else if (eicOutcome == 'fail' && eicCopies == -1) {
                eicStatus = TranslationService.getTranslation('Failed');
                eicDesc = fields.description['Failed'];
            }
            $scope.eicAccordions = fields.eicAccordions;
            $scope.commonMsg = fields.description['Common'].replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
            $scope.outcome = eicStatus;
            $scope.mainDesc = fields.description['MAINDESC'].replaceAll('[DOG NAME]', sampleDetails.petDetails.petName).replaceAll('[STATUS]', eicStatus);
            $scope.eicDescription = eicDesc.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);
            NavigationService.setNavigationUrls();
            $window.ga('send', 'pageview', {
                'page': $rootScope.pageTitle
            });
        }, function(error) {

            // promise rejected, could log the error with:
            // console.log('error', error);
        });
    }
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/eic.controller.js